module.exports = __webpack_public_path__ + "img/B3-1.a4c8ba08.jpg";